import { useMutation, type UseMutationResult } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

async function downloadFile(fileId: number): Promise<{ downloadUrl: string }> {
  return await apiClient
    .url(`/attachments/download/${fileId}`)
    .get()
    .json<{ downloadUrl: string }>();
}

export function useDownloadFile(): UseMutationResult<
  void,
  Error,
  number,
  unknown
> {
  return useMutation<void, Error, number, unknown>({
    mutationFn: async (fileId: number) => {
      const { downloadUrl } = await downloadFile(fileId);

      // Create an anchor element to trigger the download
      const link = document.createElement("a");

      link.href = downloadUrl;
      // The 'download' attribute can be used to suggest a filename,
      // but S3 will provide the actual filename via Content-Disposition.
      // link.setAttribute("download", "filename.ext"); // Optional

      // Append to the document, click, and then remove
      document.body.append(link);
      link.click();
      link.remove();
    },
  });
}
